<template>
  <div>
    <div 
      v-show="resettingpassword==false"
      class="card mx-auto col-12 col-md-8 col-lg-6 px-0 mx-0 border-0"
    >
      <div class="card-header p-0 border-0">
        <div
          class="col-12 pt-4 pb-4 text-center"
          :class="gdqmodeclass"
          style="color: white;"
        >
          <img
            src="../assets/GDQ-Associates-White.svg"
            width=320
            alt="GDQ Logo"
          />
        </div>
        <div
          class="col-12 pt-4 pb-4 bg-primary text-center"
          style="color: white;"
        >
          <h2>Administration</h2>
        </div>
      </div>
      <div class="card-body">
        <div
          v-if="passwordhasbeenreset"
          class="alert alert-success"
          role="alert"
        >
          {{ message }}
        </div>
        <form @submit.prevent="login">
          <div class="mb-3">
            <label class="form-label">Enter your username</label>
            <input 
              v-model="i_name" 
              type="text"
              class="form-control"
              :class="{ 'is-invalid': !i_name_valid, 'g-anon': anon }"
            />
            <div v-if="!i_name_valid" class="invalid-feedback">
              User name or password incorrect
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label">Enter your password</label>
            <input 
              v-model="i_password" 
              type="password"
              class="form-control"
              :class="{ 'is-invalid': !i_password_valid }"
            />
            <div v-if="!i_password_valid" class="invalid-feedback">
              User name or password incorrect
            </div>
          </div>
          <div class="row">
            <div class="col-12 mx-auto text-center">
              <button
                class="btn btn-primary col-12 col-sm-6"
                type="submit"
              >
                <span v-show="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                <span class="icon-key me-2"></span>Login
              </button>
            </div>
          </div>
          <div class="col-12 mx-auto mt-2 text-center">
            Do you want to change your password? Click <a
              href="#"
              @click.prevent="resetpassword"
            >here</a> to reset it.
          </div>
        </form>
      </div>
    </div>
    <div
      v-show="resettingpassword==true"
      class="card mx-auto col-12 col-md-8 col-lg-6 px-0 mx-0 border-0"
    >
      <div class="card-header p-0 border-0">
        <div
          class="col-12 pt-4 pb-4 bg-primary text-center"
          style="color: white;"
        >
          <img
            src="../assets/GDQ-Associates-White.svg"
            width="300"
            alt="GDQ Logo"
          >
        </div>
      </div>
      <div class="card-body">
        <h4>Reset password</h4>
        <form @submit.prevent="sendpasswordlink">
          <div class="mb-3">
            <label class="form-label">Enter your e-mail address</label>
            <input
              v-model="passwordemail"
              type="email"
              class="form-control"
              :class="{ 'is-invalid': passwordemail_valid === false }"
            />
            <div v-if="passwordemail_valid === false" class="invalid-feedback">
              Invalid e-mail address
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-5 text-start pb-4">
              <button
                class="btn btn-secondary col-12"
                type="button"
                @click.prevent="resettingpassword=false"
              >
                <span class="me-2"></span>Back to login
              </button>
            </div>
            <div class="col-12 col-lg-7 text-end">
              <button
                class="btn btn-primary col-12"
                type="submit"
              >
                <span class="icon-key me-2"></span>Send me the link!
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-console */
import { config } from '../../config'
export default {
  name: 'Login',
  components: {
  },
  data() {
    return {
      gdqmodeclass: (config.mode == 'live') ? 'bg-primary' : config.mode == 'stage' ? 'bg-warning' : 'bg-danger', 
      i_name: "",
      i_name_valid: true,
      i_password: "",
      i_password_valid: true,
      resettingpassword: false,
      passwordhasbeenreset: false,
      message: '',
      passwordemail: '',
      passwordemail_valid: null,
      loading: false,
      goto: this.$store.state.routeafterlogin,
    }
  },
  computed: {
    anon: function() {
      return this.$store.state.anon;
    },
  },
  methods: {
    sendpasswordlink () {
      var formok = true;
      // eslint-disable-next-line
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.passwordemail) == false) {
        formok = false
      }
      if (!formok) {
        this.passwordemail_valid = false
      }
      // -----------------------------------------------
      // Look up whether we have a user for this e-mail
      // -----------------------------------------------
      var filter = {
        email: {
          operator: '=',
          value: this.passwordemail
        }
      }
      this.$store.dispatch('forgotpassword', { filter: filter })
        .then((resp) => {
          var status = resp.status
          this.passwordhasbeenreset = false
          this.message = ''
          if (status == 'OK') {
            this.passwordhasbeenreset = true
            this.message = 'An e-mail has been sent to ' + this.passwordemail + '. Please follow the instructions in the e-mail to reset your password.'
          }
          this.resettingpassword = false
        })
    },
    resetpassword () {
      this.resettingpassword = true
    },
    login: function() {
      this.loading = true;
      const i_name = this.i_name;
      const i_password = this.i_password;
      const admin = 1;
      this.$store.dispatch('login',{i_name,i_password,admin })
      .then(()=> {
        this.loading = false;
        this.$store.commit('setrouteafterlogin','')
        this.$router.push(this.goto ? this.goto : '/')}
      )
      .catch(err => {
        console.log(err);
        this.loading = false;        
        this.i_name_valid = false;
        this.i_password_valid = false;
      });
    }
  }
}
</script>
